// extracted by mini-css-extract-plugin
module.exports = {"noPaddingWrapper":"Underlay_noPaddingWrapper___3aI_","sequence":"Underlay_sequence__MVRQD","canvas":"Underlay_canvas__RUPQj","sequence2":"Underlay_sequence2__inheo"};